import { Skeleton, Table } from 'antd';
import React, { useEffect, useState } from 'react';

import { getActiveSubscriptions } from 'api-services/reporting';
import Helper from 'utilities/helper';

const UsersList = () => {
  const columns = [
    {
      title: 'Customer ID#',
      dataIndex: 'uid',
    },
    {
      title: 'Name',
      dataIndex: 'firstName',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'Plan',
      dataIndex: 'subscriptionPlan',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.subscriptionPlan.localeCompare(b.subscriptionPlan),
      filters: [
        {
          text: 'Free',
          value: 'Free',
        },
        {
          text: 'Starter',
          value: 'Starter',
        },
        {
          text: 'Premium',
          value: 'Premium',
        },
        {
          text: 'Pro',
          value: 'Pro',
        },
      ],
      onFilter: (value, record) => record.subscriptionPlan.indexOf(value) === 0,
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.startDate > b.startDate,
      render: (dateString) => Helper.getShortDate(dateString),
    }
  ];

  const [userData, setUserData] = useState([]);
  const [skeleton, setSkeleton] = useState(true);

  useEffect(() => {
    const fetchUsersData = async () => {
      setSkeleton(true);
      const response = await getActiveSubscriptions();
      if (response.status === 200) {
        setUserData(response.data);
      }
      setSkeleton(false);
    };

    fetchUsersData();
  }, []);

  return (
    <div>
      <h2>User List</h2>
      {skeleton && <Skeleton active />}
      {!skeleton && <Table
        shouldUpdate
        dataSource={userData}
        size='small'
        rowKey={(record) => record.uid}
        pagination={{
          pageSize: 5,
          hideOnSinglePage: true,
        }}
        columns={columns}
      />}
      
    </div>
  );
};

export default UsersList;
